var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MulticastDelegate3 } from "flavr-common";
import { PeerFile } from "./PeerFile";
export class PeerRemoteFile extends PeerFile {
    constructor(fileId) {
        super(fileId);
        this.isOpened = false;
        this.isClosed = false;
        this.isLaoding = false;
        this.isLoaded = false;
        this.hasError = false;
        this.onLoaded = new MulticastDelegate3();
        this.onError = new MulticastDelegate3();
        this.onUnloaded = new MulticastDelegate3();
        this.clientsData = new Map();
    }
    getFileInfo() {
        let info = undefined;
        if (this.owner) {
            info = this.clientsData.get(this.owner);
            if (info)
                return info;
        }
        if (this.creator) {
            info = this.clientsData.get(this.creator);
            if (info)
                return info;
        }
        return info;
    }
    getData() {
        return __awaiter(this, void 0, void 0, function* () {
            const info = this.getFileInfo();
            if (!info)
                return undefined;
            return info.data;
        });
    }
    onLoadedPromise() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoaded)
                return;
            return yield new Promise((resolve, reject) => {
                if (this.hasError) {
                    reject("File has an error");
                    return;
                }
                const onLoaded = (_file, clientId, _info) => {
                    this.onLoaded.remove(onLoaded);
                    this.onError.remove(onError);
                    this.onUnloaded.remove(onUnloaded);
                    resolve(clientId);
                };
                const onUnloaded = () => {
                    this.onError.remove(onError);
                    this.onLoaded.remove(onLoaded);
                    this.onUnloaded.remove(onUnloaded);
                    reject();
                };
                const onError = () => {
                    this.onError.remove(onError);
                    this.onLoaded.remove(onLoaded);
                    this.onUnloaded.remove(onUnloaded);
                    reject();
                };
                this.onLoaded.add(onLoaded);
                this.onUnloaded.add(onUnloaded);
                this.onError.add(onError);
            });
        });
    }
    handleUnload(clientId) {
        this.isLoaded = false;
        this.isLaoding = false;
        let info = this.clientsData.get(clientId);
        if (!info) {
            info = this.getFileInfo();
        }
        if (!info) {
            return;
        }
        this.onUnloaded.invoke(this, clientId, info);
    }
    handleLoaded(clientId, info, creator, owner) {
        this.creator = creator;
        this.owner = owner;
        this.hasError = false;
        this.isLaoding = false;
        this.isLoaded = true;
        this.onLoaded.invoke(this, clientId, info);
    }
    handleError(clientId, error) {
        console.log("[multiplayer] PeerRemoteFile: handleError", this.fileId);
        this.isLoaded = false;
        this.isLaoding = false;
        this.hasError = true;
        this.onError.invoke(this, clientId, error);
    }
}
